import React from 'react';
import { hot } from 'react-hot-loader';
import Filter from '../../hocs/Filter/Filter';
import ErrorBoundary from '../../hocs/ErrorBoundary/ErrorBoundary';
import ProductItem from './ProductItem';
import Breadcrumbs from './Breadcrumbs';
import s from './ProductList.scss';

const ProductList = (props) => (
	<div className={s.productList}>
		<Breadcrumbs {...props} />
		<ErrorBoundary message="Filter:" debugData={props.filtering}>
			<Filter ListComponent={ProductItem} {...props} />
		</ErrorBoundary>
	</div>
);

export default hot(module)(ProductList);
